/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./api/QueryProviderAPI',
	'underscore'
], (APIFactory, QueryProviderAPI, _) => {

	class SummaryQueryProvider {
		constructor(options) {
			const features = options && options.features;
			if (features) {
				this._mainProvider = features.QueryProvider;
			}

			const queryExecution = features && features.DataQueryExecution;
			if (queryExecution) {
				queryExecution.registerQueryProvider(this.getAPI());
			}
		}

		getAPI() {
			if (!this.api) {
				this.api = APIFactory.createAPI(this, [QueryProviderAPI]);
			}
			return this.api;
		}

		getType() {
			return 'summary';
		}

		getQuerySpecList() {
			const querySpecList = this._mainProvider && this._mainProvider.getQuerySpecList();
			return _.chain(querySpecList)
			// Get the main query (ie. filter out minmax query)
				.filter(entry => {
					return entry.type === 'main';
				})
			// update the query spec type
				.map(entry => {
					_.extend(entry.spec, {
						type: 'summary'
					});
					return entry;
				})
				.value();
		}

	}
	return SummaryQueryProvider;
});
